import React, { Fragment, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { NotificationManager } from 'react-notifications';

export default function ClickCopyLabel({ text, label }) {
	const onClick = () => {
		navigator.clipboard.writeText(text);
		NotificationManager.info(`Copied`);
	};
	return (
		<Fragment>
			<div onClick={onClick} className="cursor-pointer text-blue-600">
				<FontAwesomeIcon icon={faCopy} /> {label || text}
			</div>
		</Fragment>
	);
}
